import React from 'react';
import SelectField from '@markinson/uicomponents-v2/SelectField';
import { isShallowEqual } from 'utils/utils';

interface ISelectContainerProps {
  apiPrefs?: any;
  params?: any;
  results?: any;
  value?: any;
  operationMode?: string;
  defaultValue?: string;
  sort?: boolean;
  defaultFirstValue?: boolean;
  options?: any[];
  name?: string;
  label?: string;
  width?: string;
  size?: string;
  disabled?: boolean;
  onChange?(value: any): void;
  fetchLookupOptions?(apiPrefs: any): void;
  onOptionsUpdate?(): void;
  [x: string]: any;
}

const SelectContainer = ({
  apiPrefs,
  params,
  fetchLookupOptions,
  onOptionsUpdate,
  results,
  value,
  operationMode,
  defaultValue,
  sort,
  defaultFirstValue,
  onChange,
  options,
  name,
  ...rest
}: ISelectContainerProps) => {
  const [data, setData] = React.useState<any[]>(options || []);

  React.useEffect(
    () => {
      if (apiPrefs?.path) fetchLookupOptions?.({ ...apiPrefs, params: { ...apiPrefs.params, ...params } });
    },
    [apiPrefs, params, fetchLookupOptions]
  );

  React.useEffect(
    () => {
      if (apiPrefs) {
        const newOptionsData = results?.[apiPrefs.path];
        if (newOptionsData && !isShallowEqual(newOptionsData.Data, data)) {
          setData(newOptionsData.Data);
          if (onOptionsUpdate) {
            onOptionsUpdate();
          }
        }
      }
    },
    [apiPrefs, results, data, onOptionsUpdate]
  );

  const handleDefaultValue = React.useCallback(
    () => {
      if (apiPrefs) {
        const optionsDataResults = results?.[apiPrefs.path];
        if (optionsDataResults && optionsDataResults.Data) {
          const opts = optionsDataResults.Data;
          if (opts && sort) {
            opts.sort((a, b) => {
              if (a.label === 'None') {
                return -1;
              }

              return (a.label > b.label) ? 1 : (b.label > a.label) ? -1 : 0;
            });
          }
          if (defaultValue === 'None' && !opts.find((item) => item.label === 'None')) {
            opts.unshift({ value: '0', label: 'None' });
          }
          if ((operationMode === 'NEW' || defaultFirstValue) && !value) {
            if (opts[0].value === '0') {
              if (onChange) {
                onChange(value);
              }
            } else {
              if (onChange) {
                onChange(opts[0].value);
              }
            }
          }
        }
      }
    },
    [apiPrefs, results, sort, defaultValue, operationMode, defaultFirstValue, value, onChange]
  );

  React.useEffect(
    () => {
      handleDefaultValue();
    },
    [handleDefaultValue]
  );

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    let { value: dropDownValue } = event.target;
    if (dropDownValue === '0') {
      dropDownValue = null;
    }
    if (onChange) {
      onChange(dropDownValue);
    }
  };

  const optionsData = apiPrefs ? results?.[apiPrefs.path] : null;

  return (
    <SelectField
      options={(optionsData && optionsData.Data) || options || []}
      name={name}
      value={(value === '' || value === null) && defaultValue === 'None' ? '0' : value}
      onChange={handleChange}
      {...rest}
    />
  );
};

export default SelectContainer;
